import React, { Fragment } from 'react'
import Configurator from '../../configurator'
import SnIcon from '../../front/components/shared/sn-icon'

const facebookIcon = '/images/socials/Facebook.svg'
const instagramIcon = '/images/socials/Instagram.svg'

export default class SFNFooter extends Configurator {

    /**
     * Render partners column
     *
     * @return {*}
     */
    renderSocialCol = () => {
        const FBLink = this.config.REACT_APP_SFN_FACEBOOK_LINK
        const InstagramLink = this.config.REACT_APP_SFN_INSTAGRAM_LINK

        return(
            <Fragment>
                <div className="d-flex justify-content-center justify-content-md-end align-items-center">
                    <a
                        href={this.config.REACT_APP_INFO_EMAIL}
                        className="btn btn-color-gray-dark-1 d-flex Footer__social-logo align-items-center"
                    >
                        Contact us <SnIcon className="sn-icon sn-invitation sn-sm pl-2 text-color-white" />
                    </a>
                    <a href={FBLink} target="_blank" rel="noopener noreferrer" className="Footer__social-logo">
                        <img src={facebookIcon} alt=""/>
                    </a>
                    <a href={InstagramLink} target="_blank" rel="noopener noreferrer" className="Footer__social-logo mr-0">
                        <img src={instagramIcon} alt=""/>
                    </a>
                </div>
            </Fragment>
        )
    }

    /**
     * Render
     *
     * @return {*}
     */
    render = () => (
        <footer className="bg-color-gray-light-2 p-5">
            <div className="container">
                <div className="row">
                    <div className="col-md-6 col-sm-12 align-items-center d-flex mb-4 mb-md-0">
                        <img src={`${this.config.REACT_APP_SFN_IMAGES_FOLDER}sfn-logo.svg`} alt="" />
                        <div className="font-weight-extra-bold">Simple football network</div>
                    </div>
                    <div className="col-md-6 col-sm-12">
                        {this.renderSocialCol()}
                    </div>
                </div>
            </div>
        </footer>
    )
}
